<template>
  <section class="grid grid-cols-1" :class="gap">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'm-grid-list',
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    gap() {
      switch (this.size) {
        case 'sm':
          return 'gap-y-2';
        case 'lg':
          return 'gap-y-8';
        case 'md':
        default:
          return 'gap-y-4';
      }
    },
  },
};
</script>

<style>

</style>
